const FNV_PRIME = 0x01000193;
// Pass 1 seeds with the standard 32-bit FNV-1a offset basis; pass 2 with the
// high word of the canonical 64-bit offset basis.
const OFFSET_BASIS_PASS_1 = 0x811c9dc5;
const OFFSET_BASIS_PASS_2 = 0xcbf29ce4;

const fnv1a32 = (input: string, offsetBasis: number): string => {
  let hash = offsetBasis;
  for (let i = 0; i < input.length; i++) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
};

// Digest of the base64 participant state, used as schedule-cache identity:
// two 32-bit FNV-1a passes with distinct offset bases, concatenated to 16 hex
// chars. Must stay synchronous: it runs on every cache lookup.
export const hashParticipantState = (participantState: string): string =>
  fnv1a32(participantState, OFFSET_BASIS_PASS_1) +
  fnv1a32(participantState, OFFSET_BASIS_PASS_2);
